import React, { Fragment, Component } from 'react';
import Header from './Header';
import {Link} from "react-router-dom";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export default class Home extends Component {
    constructor() {
        super();

        this.state = {
            seeking: 'travelers',
        };

        this.handleSeeking = this.handleSeeking.bind(this);

        cookies.set('tT', 'fb1', { path: '/' })
    }

    handleSeeking(value) {
        this.setState({seeking: value})
    }

    render() {
        return (
            <Fragment>
                <Header id="header-05" className="header">
                    <DiscountBanner/>
                    <div className="container">
                        <div className="row background-container fb1">
                            <WelcomeMessage />
                            <div className='bg-home-new fb1'>
                                <img src={'/images/freebird-home.jpg'} alt="Join Freebird Club"/>
                            </div>
                        </div>
                        <div className="row pt-4 pt-md-0 px-md-0 cards-home-container">
                            <div className="container d-md-flex">
                                <div className="col-md-6 mb-4 mb-md-0 card card-home mr-md-2" onClick={() => this.props.history.push('search?seeking=locals')}>
                                    <div className="card-body px-0 py-3">
                                        <div className="d-flex">
                                            <div className="card-home-image">
                                                <img src="/images/home/find-locals.png" alt="Freebird find locals"/>
                                            </div>
                                            <div className="card-home-content fb1">
                                                <h4>Locals bring locations to life</h4>
                                                <p className="font-size-16">
                                                    Get tips & recommendations from local members and enjoy authentic experiences on your travels.
                                                </p>
                                                <Link to="/search?seeking=locals" className="btn btn-block btn-cta-min">
                                                    Find Locals
                                                    <span className="float-right">
                                                        <i className="fa fa-arrow-right"></i>
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-4 mb-md-0 card card-home ml-md-2">
                                    <div className="card-body px-0 py-3">
                                        <div className="d-flex">
                                            <div className="card-home-image">
                                                <img src="/images/home/find-homestays.png" alt="Freebird find homestays"/>
                                            </div>
                                            <div className="card-home-content fb1">
                                                <h4>New friends are waiting</h4>
                                                <p className="font-size-16">
                                                    Meet like-minded members from all over the globe. Reach out, and make friends.
                                                </p>
                                                <Link to="/signup" className="btn btn-block btn-cta-min">
                                                    Join Today
                                                    <span className="float-right">
                                                        <i className="fa fa-arrow-right"></i>
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Header>
                <HowItWorks/>
                <CTA1/>
                <WhySection />
                <Testimonials />
                <MediaLogos />
                <CTA2/>
            </Fragment>
        );
    }
}

const DiscountBanner = () => (
    cookies.get('dC') == '50.1' ?
        <section className="dba">
            <div className="container">
                <Link to='/signup'
                    onClick={e => window.fbq('track', 'Lead')}>
                    <img src="/images/eb-disc-1.jpg" alt=""/>
                </Link>
            </div>
        </section>
    : null
);

const WelcomeMessage = () => (
    <div className="col-md-5 home-intro">
        <div className="intro-text">
            <h3 className='fbc-pre-title'>It's time to explore...</h3>
            <h1>The social travel club for over 50s like you</h1>
            <p className="pre-message">
                Connect with like-minded members in destinations
                of interest for local tips, advice, meet-ups & homestays.
            </p>
            <p className='fbc-sub-title sub-message'>
                Because the measure of a journey is in the smiles
                not the miles.
            </p>
        </div>
    </div>
);

const HowItWorks = (props) => (
    <section id="how-it-works" className="how-it-works">
        <div className="container">
            <div className="row">
                <div id="home-how-it-works-title" className="col-sm-12">
                    <div className="section-intro-text">
                        <h3 className='fbc-pre-title'>Let's explain...</h3>
                        <h1>WHAT IT IS</h1>
                        <p className="font-size-16">
                            Freebird Club is a community for people who love travel - but also love helping other people
                            travel too. As a member you can tap into the authentic local insight &#38; experience of other
                            members, as well as sharing your own insider knowledge with those visiting your area.
                            At any one time, Freebirds may be at home or away, but we are always Freebird friends,
                            and we&#39;re here to help each other fly.
                        </p>
                        <h1>HOW IT WORKS</h1>
                        <p className="font-size-16">
                            It all starts by becoming a member. Complete your profile and your interests. Once approved,
                            you can start to connect with like-minded members, whether you&#39;re interested in travelling
                            yourself, or helping others to enjoy your local area too.
                        </p>
                    </div>
                </div>
                <div id="home-how-it-works-cols" className="card mb-3 border-0 col-12 px-0" style={{ maxWidth: '100%' }}>
                    <div className="row content-container">
                        <div className="col-md-6 how-left">
                            <div className="what-it-is-title-block">
                                <h2>When you&#39;re in travel mode</h2>
                            </div>
                            <img src="/images/home/how-it-works-travelers-1500.jpg" alt=""/>
                            <h5 className="card-title">Search destinations & see who&#39;s there</h5>
                            <p className="card-text">
                                Choose a destination of interest. Find local members who can give tips and
                                recommendations, and maybe even meet you when you get there. You can
                                also find local hosts with an available room with whom you can stay.
                            </p>
                            <h5 className="card-title">Enjoy authentic local experiences</h5>
                            <p className="card-text">
                                Plan your trip with the help of local knowledge. Arrange meet-ups with locals
                                &amp; do something fun together. Enjoy the unique hospitality of a homestay.
                                It&#39;s all about making connections and sharing authentic experiences with
                                fellow members.
                            </p>
                        </div>
                        <div className="col-md-6 how-right">
                            <div className="what-it-is-title-block">
                                <h2>When you&#39;re in homebird mode</h2>
                            </div>
                            <img src="/images/home/how-it-works-locals-1500.jpg" alt=""/>
                            <h5 className="card-title">Share your local scene & give advice</h5>
                            <p className="card-text">
                                Enlighten travelling members seeking local tips & advice, maybe arrange
                                to meet & do something together. It&#39;s a super way to connect and meet
                                interesting new people, as well as enjoying your home turf like a tourist.
                            </p>
                            <h5 className="card-title">Make new friends & join group discussions</h5>
                            <p className="card-text">
                            Join a topical discussion, start a group chat or just reach out to a member
                            of the community. Freebirds are waiting to meet you and make new friends.
                            Share your travel experiences or just help brighten up somebody&#39;s day.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

const CTA1 = (props) => (
    <section id="cta-1" className="cta">
        <div className="container">
            <div className="row content-container">
                <div className="col-md-6 cta-left">
                    <h2>Join Freebird Club</h2>
                    <p className="card-text">
                        Become a member today and start meeting like-minded travellers from around the globe.
                    </p>
                </div>
                <div className="col-md-6 cta-right">
                    <Link to='/signup'
                    className="btn btn-block btn-join text-decoration-none py-2"
                    onClick={e => window.fbq('track', 'Lead')}>
                        Click here to join Freebird Club
                    </Link>
                </div>
            </div>
        </div>
    </section>
);

const WhySection = () => (
    <section id="whatMakesFreebirdSpecial" className="py-4 py-md-5">
        <div className="container">
            <div className="row">
                <div className="card mb-0 mb-md-3 border-0" style={{ maxWidth: '100%' }}>
                    <div className="row no-gutters">
                        <div className="col-md-5 image-container d-md-none px-3">
                            <img src="/images/what-makes-freebird-special.png" className="card-img" alt="what makes freebird special"/>
                        </div>
                        <div className="col-md-7 special-txt">
                            <div className="card-body pl-md-0">
                                <h5 className="card-title">What makes Freebird Club special</h5>
                                <p className="card-text font-size-16">Freebird is about more than just travel. Our members are
                                    socially & culturally curious and are keen to connect with others whether on the
                                    road or on their own turf. Freebird is about discovering & sharing our local places,
                                    cultures and experiences - and making friends along the way. Join Freebird Club to
                                    enjoy more meaningful travel and new social interactions at home and away.
                                </p>
                                <div className="icons col-12 row">
                                    <div className="col-6 d-flex px-0 my-3">
                                        <div className="icon-container">
                                            <img src="/images/icons/travel.svg" alt=""/>
                                        </div>
                                        <span>
                                            Travel
                                        </span>
                                    </div>
                                    <div className="col-6 d-flex px-0 my-3">
                                        <div className="icon-container">
                                            <img src="/images/icons/meet-ups.svg" alt=""/>
                                        </div>
                                        <span>
                                            Meet ups
                                        </span>
                                    </div>
                                    <div className="col-6 d-flex px-0 my-3">
                                        <div className="icon-container">
                                            <img src="/images/icons/local-tips.svg" alt=""/>
                                        </div>
                                        <span>
                                            Local tips
                                        </span>
                                    </div>
                                    <div className="col-6 d-flex px-0 my-3">
                                        <div className="icon-container">
                                            <img src="/images/icons/homestays.svg" alt=""/>
                                        </div>
                                        <span>
                                            Homestays
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5 image-container d-none d-md-block special-img">
                            <img src="/images/what-makes-freebird-special.png" className="card-img desktop-image" alt="what makes freebird special"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

const Testimonials = (props) => (
    <section id="testimonials" className="testimonials">
        <div className="container">
            <div className="row">
                <div id="testimonials-title" className="col-sm-12">
                    <div className="section-intro-text">
                        <h1>Testimonials</h1>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-6 col-md-4">
                    <div className="box-1">
                        <img src="/images/home/flag-icon-can.jpg" alt=""/>
                        <div className="testimonial-text">
                            <h3>Canada</h3>
                            <img src="/images/home/map-pin.svg" alt=""/>
                            <h2>Annette</h2>
                            <p>
                                &quot;What a wonderful thing to be bringing people together and
                                providing joy through friendship and travel.&quot;
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-xs-6 col-md-4">
                    <div className="box-1">
                        <img src="/images/home/flag-icon-uk.jpg" alt=""/>
                        <div className="testimonial-text">
                            <h3>UK</h3>
                            <img src="/images/home/map-pin.svg" alt=""/>
                            <h2>Nicola</h2>
                            <p>
                                &quot;My first experience with Freebird was wonderful. My husband and I
                                really enjoyed Catherine's stay, and did many local things with her.
                                Freebird is an inspired idea.&quot;
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-xs-6 col-xs-offset-3 col-md-4 col-md-offset-0">
                    <div className="box-1">
                        <img src="/images/home/flag-icon-ned.jpg" alt=""/>
                        <div className="testimonial-text">
                            <h3>Netherlands</h3>
                            <img src="/images/home/map-pin.svg" alt=""/>
                            <h2>Johan</h2>
                            <p>
                                &quot;Finally, something inspiring for the mature segment of human beings! Well done to the Freebird Club.&quot;
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-6 col-md-4">
                    <div className="box-1">
                        <img src="/images/home/flag-icon-usa.jpg" alt=""/>
                        <div className="testimonial-text">
                            <h3>USA</h3>
                            <img src="/images/home/map-pin.svg" alt=""/>
                            <h2>William</h2>
                            <p>
                                &quot;Such nice people you have in the Freebird Club!
                                I look forward to meeting more in the years to come.&quot;
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-xs-6 col-md-4">
                    <div className="box-1">
                        <img src="/images/home/flag-icon-sou.jpg" alt=""/>
                        <div className="testimonial-text">
                            <h3>South Africa</h3>
                            <img src="/images/home/map-pin.svg" alt=""/>
                            <h2>Lola</h2>
                            <p>
                                &quot;This is such a great way to make new friends.
                                I will be 60 soon and going places alone is a downer.&quot;
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-xs-6 col-xs-offset-3 col-md-4 col-md-offset-0">
                    <div className="box-1">
                        <img src="/images/home/flag-icon-aus.jpg" alt=""/>
                        <div className="testimonial-text">
                            <h3>Australia</h3>
                            <img src="/images/home/map-pin.svg" alt=""/>
                            <h2>Mary</h2>
                            <p>
                                &quot;I love this so much. You should never live life on your couch.
                                Just because we have reached a certain age does not mean we can't
                                experience new things.&quot;
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

const MediaLogos = () => {
    let featuredLinks = [
        {
            id: 1,
            link: 'https://www.forbes.com/sites/nextavenue/2017/12/05/the-freebird-club-an-airbnb-for-the-50-set/#3464acf6463c',
            imageLink: '/images/freebird/media/forbes.webp',
            title: "Forbes"
        },
        {
            id: 2,
            link: 'https://www.thetimes.co.uk/article/airbnb-style-hosting-site-for-over-50s-can-stop-loneliness-hmfvl6jrp',
            imageLink: '/images/freebird/media/times.webp',
            title: 'The Times'
        },
        {
            id: 3,
            link: 'https://www.independent.ie/life/travel/travel-news/empty-nesters-get-set-to-fly-36449163.html',
            imageLink: '/images/freebird/media/independent.webp',
            title: 'Independent.ie'
        },
        {
            id: 4,
            link: 'https://www.irishtimes.com/life-and-style/abroad/free-as-a-bird-and-looking-for-a-room-1.3221351',
            imageLink: '/images/freebird/media/irishtimes.webp',
            title: 'The Iris Times'
        },
        {
            id: 5,
            link: 'http://www.nextavenue.org/freebird-club-airbnb-50/',
            imageLink: '/images/freebird/media/nextavenue.webp',
            title: "Next Avenue"
        },
        {
            id: 6,
            link: 'https://www.traveler.es/experiencias/articulos/freebird-club-comunidad-viajera-para-mayores-de-50-anos/13165',
            imageLink: '/images/freebird/media/traveler.webp',
            title: "Condé Nast Traveler"
        },
        {
            id: 7,
            link: 'https://www.huffingtonpost.com/entry/airbnb-for-seniors-helps-link-travelers-with-like-minded-hosts_us_57487aa1e4b0dacf7ad4c130?guccounter=1',
            imageLink: '/images/freebird/media/huffpost.webp',
            title: "Huffpost"
        },
        {
            id: 8,
            link: 'http://www.telegraph.co.uk/property/renting/meet-the-freebird-club-a-new-typeof-airbnb-for-the-50-plus-adven/',
            imageLink: '/images/freebird/media/telegraph.webp',
            title: "The Telegraph"
        }
    ];
    return (
        <section id="place_location_05" className="place_location_05">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="sub-title">
                            <h2>We are featured in...</h2>
                        </div>
                    </div>
                </div>
                <div className="row ">
                    {
                        featuredLinks.map((item) => {
                            return <div className="col-6 col-sm-3 pb-30" key={item.id}>
                                <a className="image-container" href={item.link} target="_BLANK">
                                    <img
                                        src={item.imageLink}
                                        alt={item.title}
                                        className="img-fluid mx-auto d-block"
                                    />
                                </a>
                                <a href={item.link} target="_BLANK" className="btn btn-read-article btn-block">Read article</a>
                            </div>
                        })
                    }
                </div>
            </div>
        </section>
    )
};

const CTA2 = (props) => (
    <section id="cta-1" className="cta">
        <div className="container">
            <div className="row content-container">
                <div className="col-md-6 cta-left">
                    <h2>Join Freebird Club</h2>
                    <p className="card-text">
                        Make new friends, share travel tips with other members, and even arrange a meet-up at your chosen destination.
                    </p>
                </div>
                <div className="col-md-6 cta-right">
                    <Link to='/signup' className="btn btn-block btn-join text-decoration-none py-2">
                        Click here to join Freebird Club
                    </Link>
                </div>
            </div>
        </div>
    </section>
);
